import { Component, Input, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import {enableLogging} from '../../../environments/environment'
@Component({
  selector: 'app-active-ingredient',
  templateUrl: './active-ingredient.component.html',
  styleUrls: ['./active-ingredient.component.scss']
})
export class ActiveIngredientComponent implements OnInit {
@Input() videoUrl;
@Input() activeIngredients;
@Input() activeIngredientsDesc;
  played = false;
  value = 30;
  playStatusEmiiter = new BehaviorSubject<Boolean>(this.played);
  constructor() { }

  ngOnInit(): void {
  }

  onPause(event, vid: HTMLVideoElement){
    if(vid){

      enableLogging && console.log("video state", vid.paused);

      enableLogging &&  console.log("check the target",event.target.classList[0] ===  "material-icons");
      if(event.target.classList[0] ===  "material-icons"){
        if (vid.requestFullscreen) {
          vid.requestFullscreen();
        }
      }else{
        if(!vid.paused){
          this.played = false;
          this.playStatusEmiiter.next(this.played);
          vid.pause()
        }else{
          this.played = true;
          this.playStatusEmiiter.next(this.played);
          vid.play();
        }

      }



      enableLogging && console.log(vid.paused);
    }

  }

}
